import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "addressContainer" }
const _hoisted_2 = {
  key: 0,
  class: "boxTitle"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-sm-12"
}
const _hoisted_5 = { class: "form-group col-sm-10" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_7 = {
  key: 0,
  class: "form-control"
}
const _hoisted_8 = { class: "form-group col-sm-2" }
const _hoisted_9 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_10 = {
  key: 0,
  class: "form-control"
}
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "form-group col-md-4" }
const _hoisted_13 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_14 = {
  key: 0,
  class: "form-control"
}
const _hoisted_15 = { class: "form-group col-md-4" }
const _hoisted_16 = {
  key: 0,
  class: "form-control"
}
const _hoisted_17 = { class: "form-group col-md-4" }
const _hoisted_18 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_19 = {
  key: 0,
  class: "form-control"
}
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "form-group col-8" }
const _hoisted_22 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_23 = {
  key: 0,
  class: "form-control"
}
const _hoisted_24 = { class: "form-group col-4" }
const _hoisted_25 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_26 = {
  key: 0,
  class: "form-control"
}
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = {
  key: 0,
  class: "form-control"
}
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = {
  key: 0,
  class: "form-control"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_google_autocomplete = _resolveComponent("google-autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.readonly)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_google_autocomplete, {
              modelValue: _ctx.googleAddress,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.googleAddress) = $event))
            }, null, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _cache[10] || (_cache[10] = _createTextVNode("Via ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.localValue.street || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.street) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.street]
            ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", null, [
          _cache[11] || (_cache[11] = _createTextVNode("Civico ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.localValue.streetNumber || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localValue.streetNumber) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.streetNumber]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", null, [
          _cache[12] || (_cache[12] = _createTextVNode("Città ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.localValue.city || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localValue.city) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.city]
            ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[13] || (_cache[13] = _createElementVNode("label", null, "Regione", -1)),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.localValue.region || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localValue.region) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.region]
            ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("label", null, [
          _cache[14] || (_cache[14] = _createTextVNode("Nazione ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.localValue.country || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localValue.country) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.country]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("label", null, [
          _cache[15] || (_cache[15] = _createTextVNode("Provincia ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_22, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(_ctx.localValue.province || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localValue.province) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.province]
            ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("label", null, [
          _cache[16] || (_cache[16] = _createTextVNode("CAP ")),
          (_ctx.showAsterisks)
            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "*"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.readonly)
          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.localValue.postalCode || '-'), 1))
          : _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              class: "form-control",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localValue.postalCode) = $event))
            }, null, 512)), [
              [_vModelText, _ctx.localValue.postalCode]
            ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _cache[17] || (_cache[17] = _createElementVNode("label", null, "Scala, piano, interno ecc.", -1)),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.localValue.addressDetails || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localValue.addressDetails) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.addressDetails]
          ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _cache[18] || (_cache[18] = _createElementVNode("label", null, "Note di contatto", -1)),
      (_ctx.readonly)
        ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_ctx.localValue.notes || '-'), 1))
        : _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 1,
            class: "form-control",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localValue.notes) = $event))
          }, null, 512)), [
            [_vModelText, _ctx.localValue.notes]
          ])
    ])
  ]))
}